module.exports = __webpack_public_path__ + "img/xiaozi_xinxi.4f46f3db.svg";